import { mollieCredentialSupportsManagedNextGen } from "../../../../ingestion/config.ts";
import type {
  BillingProviderBinding,
  BillingWebhookManagementCapability,
} from "../types.ts";

export function resolveMollieWebhookManagementCapability(
  binding: BillingProviderBinding
): BillingWebhookManagementCapability {
  const live = binding.credentials.live;
  const test = binding.credentials.test;
  const kind = live?.kind ?? test?.kind;
  if (
    kind === "api_key" ||
    kind === "secret_key" ||
    kind === "restricted_key"
  ) {
    return {
      classic: true,
      nextGen: {
        available: false,
        reason: "api_key_classic_only",
      },
    };
  }
  if (mollieCredentialSupportsManagedNextGen(kind)) {
    const authority = binding.providerConfig.authority;
    const scope =
      authority && typeof authority === "object"
        ? (authority as { scope?: { kind?: unknown } }).scope
        : undefined;
    const webhooksWrite =
      authority && typeof authority === "object"
        ? (
            authority as {
              permissions?: { webhooks?: { write?: unknown } };
            }
          ).permissions?.webhooks?.write
        : undefined;
    if (scope?.kind !== "organization" || webhooksWrite !== true) {
      return {
        classic: true,
        nextGen: {
          available: false,
          reason: "credential_missing_webhooks_write",
        },
      };
    }
    return {
      classic: true,
      nextGen: {
        available: true,
        reason: "verified_organization_webhooks_write",
      },
    };
  }
  return {
    classic: true,
    nextGen: {
      available: false,
      reason: "credential_missing_webhooks_write",
    },
  };
}
